import React from 'react';
import { AlertTriangle, RotateCcw } from '../../bravosIcons';
import { TrainerDialog } from './TrainerDialog';

export interface PlanTrimDaysDialogProps {
  open: boolean;
  currentDays: number;
  targetDays: number;
  lostIndices: number[];
  onConfirm: () => void;
  onCancel: () => void;
}

export function PlanTrimDaysDialog({
  open,
  currentDays,
  targetDays,
  lostIndices,
  onConfirm,
  onCancel,
}: PlanTrimDaysDialogProps) {
  const removedCount = currentDays - targetDays;
  const lostCount = lostIndices.length;
  const title = lostCount === 1 ? 'Remove a programmed day?' : 'Remove programmed days?';

  return (
    <TrainerDialog
      open={open}
      role="alertdialog"
      titleId="twp-trim-title"
      size="lg"
      showClose
      onClose={onCancel}
      className="twp-dialog-scrim"
      panelClassName="twp-dialog"
      footer={
        <>
          <button type="button" className="tr-btn-ghost" onClick={onCancel}>
            Keep {currentDays} days
          </button>
          <button type="button" className="tr-btn-danger--filled" onClick={onConfirm}>
            Remove {removedCount} day{removedCount === 1 ? '' : 's'}
          </button>
        </>
      }
    >
      <div className="twp-dialog-icon" aria-hidden>
        <AlertTriangle size={22} strokeWidth={2} />
      </div>
      <h2 id="twp-trim-title" className="tr-dialog__title" style={{ paddingRight: 0 }}>
        {title}
      </h2>
      <p className="twp-dialog-text">
        Shortening this plan to <strong>{targetDays} day{targetDays === 1 ? '' : 's'}</strong> removes{' '}
        <strong>{removedCount} day{removedCount === 1 ? '' : 's'}</strong> — including{' '}
        <strong>
          {lostCount} with workout{lostCount === 1 ? '' : 's'} already programmed
        </strong>
        :
      </p>
      <div className="twp-dialog-days">
        {lostIndices.map((idx) => (
          <span key={idx} className="twp-tag twp-tag--lost">
            Day {idx + 1}
          </span>
        ))}
      </div>
      <div className="twp-dialog-note">
        <RotateCcw size={15} strokeWidth={2} />
        You can undo this straight after.
      </div>
    </TrainerDialog>
  );
}
